import { InputBindingDevice } from "./InputBindingDevice.enum"
import { type MouseClickBinding } from "./InputRouter"
import type { MouseButton } from "./MouseButton.enum"

export default function createMouseClickBinding (
  button: MouseButton,
): MouseClickBinding {
  return {
    device: InputBindingDevice.Mouse,
    click: true,
    button,
  }
}